
define(
	'MHI.TrackingInfo.TrackingInfo'
,   [
		'MHI.TrackingInfo.TrackingInfo.View'
	]
,   function (
		TrackingInfoView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			
			var PageType = container.getComponent('PageType');

            PageType.registerPageType({
                name: 'tracking_info_page',
                routes: ['tracking'],
                view: TrackingInfoView,
                defaultTemplate: {
                    name: 'mhi_trackinginfo_trackinginfo.tpl',
                    displayName: 'Tracking Info Page'
                }
            });
		}
	};
});
